function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleUserRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.006 19c1.677 1.675 1.949 5.457 1.994 8.991A1.988 1.988 0 0125.008 30H6.99A1.987 1.987 0 015 27.991c.045-3.534.316-7.315 1.994-8.991 1.323-1.322 3.52-2.643 4.857-3.388a.989.989 0 00.23-1.547C10.69 12.583 9.995 11.333 9.995 8c0-3 2.001-6 6.003-6 4.004 0 6.005 3 6.005 6 0 3.333-.694 4.583-2.084 6.065a.989.989 0 00.229 1.547c1.338.745 3.534 2.066 4.857 3.388z",
    fill: props.color
  }));
}

export default SvgIconPeopleUserRexFilled;